import HomePage from '../pages/home-page/HomePage';
import SysAdminPage from '../pages/SysAdminPage';
import { CalendarPage } from '../components/calendar/CalendarPage';
import { ReportsListPage } from '../components/reports/ReportsListPage';
import ReportDetailDep from '../components/reports/ReportDetailDep';
import ReportDetailOrg from '../components/reports/ReportDetailOrg';
import {
  CALENDAR_ROUTE,
  SETTINGS_ROUTE,
  FROM_LINK_HOME_ROUTE,
  FROM_LINK_HISTORY_HOME_ROUTE,
  HOME_ROUTE,
  REPORTS_DETAIL_DEP_ROUTE,
  REPORTS_DETAIL_ORG_ROUTE,
  REPORTS_DETAIL_SECTOR_ROUTE,
  HELP_ROUTE,
  HELP_ROUTE_BY,
  HELP_ROUTE_CZ,
  HELP_ROUTE_KZ,
  HELP_ROUTE_PL,
  HELP_ROUTE_UA,
  HELP_ROUTE_BG,
  REPORTS_ROUTE,
  PLANNER_ROUTE,
  REPORT_PROJECT,
  PROFILE_ROUTE,
  HR_PROFILE_ROUTE,
  HELP_ROUTE_GE, HELP_ROUTE_LT, SURVEY_ROUTE, APPLICATION_TEMPLATES, ACTING_ROUTE
} from '../utils/consts';
import { ReportSector } from '../components/reports/ReportSector';
import { HelpPage } from '../components/help/HelpPage';
import { HelpPageCountry } from '../components/help/HelpPageCountry';
import { Settings } from '../components/settings/Settings';
import { ReportProject } from '../components/reports/ReportProject';
import React from 'react';
import { Planner } from '../components/planner/Planner';
import { Profile } from '../components/profile/Profile';
import { SurveyPage } from '../components/survey/SurveyPage';
import { ApplicationTemplatesPage } from '../components/application_templates/ApplicationTemplatesPage';
import { ActingPerson } from '../components/acting_person/ActingPerson';
import { AccessTypeCode } from '../types';

export interface AuthRoutesI{
  path: string,
  Element: React.FunctionComponent,
  props?: any,
  isMobileView: boolean,
  mobileTextTranslations? : {title: string, description: string},
  accTypeCode?: AccessTypeCode,
}

export const authRoutes: AuthRoutesI[] = [
  {
    path: HOME_ROUTE,
    Element: HomePage,
    isMobileView: true,
  },
  {
    path: '/sys-admin/panel',
    Element: SysAdminPage,
    isMobileView: true,
    accTypeCode: {
      type: 'ACCESSCODE',
      code: 'system.role.maintenance',
    },
  },
  {
    path: APPLICATION_TEMPLATES,
    Element: ApplicationTemplatesPage,
    isMobileView: false,
    accTypeCode: {
      type: 'MENUITEM',
      code: 'menuitem.templates'
    }
  },

  {
    path: SURVEY_ROUTE,
    Element: SurveyPage,
    isMobileView: false
  },
  {
    path: FROM_LINK_HOME_ROUTE,
    Element: HomePage,
    isMobileView: true,
  },
  {
    path: FROM_LINK_HISTORY_HOME_ROUTE,
    Element: HomePage,
    isMobileView: true,
  },
  {
    path: SETTINGS_ROUTE,
    Element: Settings,
    isMobileView: false,
    mobileTextTranslations: {title: 'Settings', description: 'Settings page'},
    accTypeCode: {
      type: 'MENUITEM',
      code: 'menuitem.settings'
    },
  },
  {
    path: ACTING_ROUTE,
    Element: ActingPerson,
    isMobileView: false,
    accTypeCode: {
      type: 'MENUITEM',
      code: 'menuitem.actingsettings'
    },
  },
  {
    path: CALENDAR_ROUTE,
    Element: CalendarPage,
    isMobileView: true,
  },
  {
    path: REPORTS_ROUTE,
    Element: ReportsListPage,
    isMobileView: false,
    mobileTextTranslations: {title: 'Reports', description: 'Reports page'},
    accTypeCode: {
      type: 'MENUITEM',
      code: 'menuitem.reports'
    },
  },
  {
    path: PLANNER_ROUTE,
    Element: Planner,
    isMobileView: false,
    mobileTextTranslations: {title: 'Planner', description: 'Planner page'}
  },

  {
    path: HELP_ROUTE,
    Element: HelpPage,
    isMobileView: true,
  },
  {
    path: REPORTS_DETAIL_DEP_ROUTE,
    Element: ReportDetailDep,
    isMobileView: false,
    mobileTextTranslations: {title: 'Department report', description: 'Department report page'},
    accTypeCode: {
      type: 'ACCESSCODE',
      code: 'report.structure.view',
    },
  },
  {
    path: REPORTS_DETAIL_ORG_ROUTE,
    Element: ReportDetailOrg,
    isMobileView: false,
    mobileTextTranslations: {title: 'Organization report', description: 'Organization report page'},
    accTypeCode: {
      type: 'ACCESSCODE',
      code: 'report.organizaton.view',
    },
  },
  {
    path: REPORTS_DETAIL_SECTOR_ROUTE,
    Element: ReportSector,
    isMobileView: false,
    mobileTextTranslations: {title: 'Sector report', description: 'Sector report page'},
    accTypeCode: {
      type: 'ACCESSCODE',
      code: 'report.structure.view',
    },
  },
  {
    path: REPORT_PROJECT,
    Element: ReportProject,
    isMobileView: false,
    mobileTextTranslations: {title: 'Project report', description: 'Project report page'},
    accTypeCode: {
      type: 'ACCESSCODE',
      code: 'report.project.view'
    },
  },
  {
    path: HELP_ROUTE_BY,
    Element: HelpPageCountry,
    isMobileView: true,
  },
  {
    path: HELP_ROUTE_BG,
    Element: HelpPageCountry,
    isMobileView: true,
  },
  {
    path: HELP_ROUTE_CZ,
    Element: HelpPageCountry,
    isMobileView: true,
  },
  {
    path: HELP_ROUTE_KZ,
    Element: HelpPageCountry,
    isMobileView: true,
  },
  {
    path: HELP_ROUTE_PL,
    Element: HelpPageCountry,
    isMobileView: true,
  },
  {
    path: HELP_ROUTE_UA,
    Element: HelpPageCountry,
    isMobileView: true,
  },
  {
    path: HELP_ROUTE_GE,
    Element: HelpPageCountry,
    isMobileView: true,
  },
  {
    path: HELP_ROUTE_LT,
    Element: HelpPageCountry,
    isMobileView: true,
  },
  {
    path: PROFILE_ROUTE,
    Element: Profile,
    isMobileView: false,
    mobileTextTranslations: {title: 'Profile', description: 'Profile page'}
  },
  {
    path: HR_PROFILE_ROUTE,
    Element: Profile,
    isMobileView: false,
    mobileTextTranslations: {title: 'Profile', description: 'Profile page'}
  },
];

